import { PipelineChart, TemperatureChart } from '../dashboard';
import type { PipelineCounts, TemperatureCounts } from '../../types';

export function PipelineConversions({ pipeline, temperature, conversions, scope }: {
  pipeline: PipelineCounts;
  temperature: TemperatureCounts;
  conversions: number;
  scope: 'all' | 'mine';
}) {
  return (
    <div className="space-y-4">
      <div className="card p-4 sm:p-6 flex items-center">
        <div>
          <div className="text-2xl font-bold tabular-nums text-gray-900 dark:text-gray-100">{conversions}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Conversions this period</div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PipelineChart data={pipeline} scope={scope} />
        <TemperatureChart data={temperature} scope={scope} />
      </div>
    </div>
  );
}
